import { writable } from 'svelte/store';
import { browserLocale } from '../i18n/locales.js';

// 설정 관련 상태를 관리하는 스토어
const defaultSettings = {
  zoomLevel: 100,                   // 이미지 줌 레벨 (%)
  selectedBackground: '눈밭',        // 배경 교체 시 선택된 배경
  searchReplacePrompt: '',          // 객체 변경 시 사용할 프롬프트
  searchRecolorColor: 'red',        // 색상 변경 시 선택된 색상
  outpaintSettings: {               // 이미지 확장 설정
    left: 512,
    right: 512,
    up: 200,
    down: 100,
    creativity: 0.5,
    prompt: '',
    selectedPreset: 'custom',       // 선택된 프리셋 (custom, FHD, QHD, 4K, 16:9, 3:2)
    imagePosition: { x: 0, y: 0 }   // 이미지 위치 (드래그 시 변경됨)
  },
  selectedStyle: '애니메이션(P)',    // 스타일 변환 시 선택된 스타일
  selectedStyleBackend: 'gpt',       // 스타일 백엔드 ('google', 'flux', 'gpt' 또는 'stability')
  subjectName: '',                   // 이름이 필요한 스타일에 표시할 주인공 이름
  controlStrength: 0.7,              // 스타일 변환 시 원본 이미지의 영향력
  preserveFace: false,               // 스타일 변환 시 얼굴 보존 여부
  inpaintSettings: {                // 인페인팅 설정
    prompt: '',
    negativePrompt: '',
    seed: 0
  },
  eraseObjectSeed: 0,               // 객체 지우기 시 사용할 시드
  removeObjectsPrompt: '',          // 객체 제거 프롬프트
  detectedObjects: [],              // 감지된 객체 목록
  selectedObjects: [],              // 선택된 제거 대상 객체 목록
  isDetecting: false,               // 객체 감지 중 여부
  secondaryImageFile: null,         // 이미지 합성을 위한 보조 이미지 파일
  compositeMode: 'ai_fitting',      // 이미지 합성 방식
  fruitType: '반으로 잘린 키위',
  groomingBreed: '',
  recentStyles: [],
  mbtiType: '',                 // 반려견 MBTI 생성 시 선택 유형
  mbtiQuizCompleted: false,
  videoStyle: 'kpop_dance',         // AI 동영상 생성 시 선택 스타일
  outputFormat: 'png',              // 출력 이미지 형식
  brushSize: 20,                    // 브러시 크기 (인페인팅, 객체 지우기용)
  brushColor: 'rgba(255, 255, 255, 1)' // 브러시 색상 (인페인팅, 객체 지우기용)
  ,language: browserLocale()
};

function loadSettings() {
  try {
    const saved = JSON.parse(localStorage.getItem('ilieon_settings') || '{}');
    return { ...defaultSettings, ...saved, language: browserLocale(saved.language), secondaryImageFile: null, detectedObjects: [], selectedObjects: [], isDetecting: false };
  } catch { return defaultSettings; }
}
export const settingsStore = writable(loadSettings());
